import { Button, Card, Input, message, Modal, Row, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { getComment, createComment, updateComment } from "src/services/comment.service";
import { CommentPayload } from "src/entity/comment/comment.entity";
import { update } from "lodash";
import { canEditTable, canViewTable } from "src/pages/VocsInventory/Combustion/PermissionCheck/PermissionCheck";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { blackListGlobalCommentsInformation } from "src/entity/common/common.constant";

const { Title, Text } = Typography;

const Comment = (props: { path: string }) => {
  const { path } = props;
  const title = "Note / Comment";
  const [isSystemAdmin, setIsSytemAdmin] = useState<boolean>(false);
  const profile = profileStore(useShallow((state) => state.profile));
  const [companyId, setCompanyId] = useState<string>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [comment, setComment] = useState<string>("Helloooo");
  const [loading, setLoading] = useState<boolean>(false);
  const [mode, setMode] = useState<string>("");
  const { permissions } = useNavigationMenu();
  const [messageApi, contextHolder] = message.useMessage();

  const intitalData = () => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }

    if (profile?.isSystemAdmin) {
      setIsSytemAdmin(profile?.isSystemAdmin);
    }
  };

  const onChangeComment = (value: string) => {
    setComment(value);
  };

  const onCancel = () => {
    setIsEdit(false);
  };

  const onCloseEdit = () => {
    setIsEdit(false);
  };

  const fetchComment = async () => {
    try {
      if (companyId && path) {
        const finalCompanyId = blackListGlobalCommentsInformation.find((item) => item === path);
        const query = {
          path,
          companyId: finalCompanyId ? null : companyId,
        };
        const response = await getComment(query);
        if (response.data.code === 200) {
          const data = response.data.data[0];
          setComment(data.comment);
          setMode("update");
        }
      }
    } catch (error) {
      setMode("insert");
      setComment("");
    } finally {
      setLoading(false);
    }
  };

  const saveComment = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let response;
        let payload: CommentPayload = {
          comment,
          path,
        };
        // console.log("mode", mode);
        const finalCompanyId = blackListGlobalCommentsInformation.find((item) => item === path);

        if (mode == "insert") {
          payload = {
            ...payload,
            companyId: finalCompanyId ? null : companyId,
          };
          response = await createComment([payload]);
        } else if (mode == "update") {
          response = await updateComment({ ...payload, companyId: finalCompanyId ? null : companyId });
        }
        if (response && response.data.code === 200) {
          messageApi.open({
            type: "success",
            content: CommonSuccess.SAVED_SUCCESSFULL,
          });
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: CommonError.SOMETHING_WRONG,
      });
    } finally {
      setLoading(false);
      onCloseEdit();
    }
  };

  useEffect(() => {
    intitalData();
  }, [profile?.activeCompany, profile?.isSystemAdmin]);

  useEffect(() => {
    setIsEdit(false);
    fetchComment();
  }, [companyId, path]);

  return (
    <>
      {contextHolder}
      <Card
        title={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>{title}</p>
            {canEditTable(permissions) && <Button type="text" icon={<FaRegEdit />} onClick={() => setIsEdit(true)} />}
          </div>
        }
        style={{ width: "100%", height: "100%" }}
      >
        {isEdit && canViewTable(permissions) ? (
          <>
            <Input.TextArea value={comment} onChange={(e) => onChangeComment(e.target.value)} rows={4} />

            <div style={{ display: "flex", justifyContent: "end", paddingTop: "15px" }}>
              <div style={{ paddingRight: "10px" }}>
                <Button type="primary" onClick={saveComment} loading={loading}>
                  Save
                </Button>
              </div>

              <Button onClick={onCancel}>Cancel</Button>
            </div>
          </>
        ) : (
          canViewTable(permissions) && <Text style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{comment}</Text>
        )}
      </Card>
    </>
  );
};

export default Comment;
